/** Checks whether a style attribute contains one of the given styles. */
export function matchesQuoteStyle(
  styleAttribute: string | null | undefined,
  styles: readonly string[],
): boolean {
  return (
    styleAttribute != null &&
    styles.some((style) => styleAttribute.includes(style))
  );
}
